<div class="col full-height layout-column" *ngIf="resource">

  <!-- Top summary resource panel list item (Table Counterpart) -->
  <div class="summary-container" #summaryContainer>
    <app-resources-table-list-row [resource]="resource"
                                 [settings]="settings.resources"
                                 [isSelected]="false"
                                 [allPanelIds]="[]"
                                 [panelId]="panel.id"
                                 [isSummaryRow]="true"
                                 (onRowClick)="onClose.emit()">
    </app-resources-table-list-row>
</div>

  <app-routes-table-list
    class="flex margin-top-5 min-height-0"
    [summaryContainer]="summaryContainer"
    [isResourceView]="true"
    [settings]="settings.routes"
    [panel]="panel"
    [panels]="panels"
    [resourcesDropListIds]="resourcesDropListIds"
    [routesDropListIds]="routesDropListIds"
    [ids]="resource.scheduleExtraData?.routeIds"
    [selectedServiceIds]="selectedServiceIds"
    [visibleIds]="visibleIds"
    (onRoutesDropped)="drop($event)"
    (onDrillDown)="onDrillDownRoute.emit($event)"
    (onSelectRouteResource)="onChangeRouteInfo.emit($event)"
    (onToggleVisible)="onToggleVisibleRoute.emit($event)"
    (onLockRouteChange)="onToggleLockedRoute($event)">
  </app-routes-table-list>
</div>
